import {MessageProps} from '../utils/types';
import React from 'react';

const PosaMessageContext = React.createContext<MessageProps>({});

export const PosaMessageProvider = PosaMessageContext.Provider;
export const PosaMessageConsumer = PosaMessageContext.Consumer;

export default PosaMessageContext;
